import { slugifyUrlSegment } from "./publicProfileUrls";

export const buildFirmNameForUrl = (name: string) => slugifyUrlSegment(name);
